/**
 * @generated SignedSource<<cae7a79b0ab5594f6fe5af9b849f0f06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorsResultContainer_items$data = ReadonlyArray<{
  readonly item: {
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_item">;
  } | null;
  readonly " $fragmentType": "SbSharedCreatorsResultContainer_items";
}>;
export type SbSharedCreatorsResultContainer_items$key = ReadonlyArray<{
  readonly " $data"?: SbSharedCreatorsResultContainer_items$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_items">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedCreatorsResultContainer_items",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "showSeller",
              "variableName": "showSeller"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "kind": "FragmentSpread",
          "name": "SharedItemTile_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchResult",
  "abstractKey": null
};

(node as any).hash = "d72ff02a7138a1f7edea803e04e3363f";

export default node;
